import { FC, HTMLAttributes } from 'react';

import { Modal } from 'antd';

import { EOnboardingStates, EOnboardingSteps, Final, Steps, useOnboardingSlice, Welcome } from 'features/Onboarding';

interface IOnboardingProps extends HTMLAttributes<HTMLDivElement> {}

export const Onboarding: FC<IOnboardingProps> = ({ ...props }) => {
	const { state, step, modalIsOpened } = useOnboardingSlice();

	return (
		<Modal
			{...props}
			width={state === EOnboardingStates.STEPS && step === EOnboardingSteps.SECOND ? 768 : 550}
			centered
			open={modalIsOpened}
			closable={false}
			footer={null}>
			{state === EOnboardingStates.WELCOME && <Welcome />}
			{state === EOnboardingStates.STEPS && <Steps />}
			{state === EOnboardingStates.FINAL && <Final />}
		</Modal>
	);
};
